import { NotificationDto } from 'gleblu-socket-api';
import moment from 'moment-timezone';

import Notification from '../interfaces/Notification';

export function fromDto(notificationDto: NotificationDto): Notification {
  const { uuid, placeUuid, message, wasShown, timestamp } = notificationDto;
  return {
    uuid,
    placeUuid,
    message,
    wasShown,
    timestamp: moment(timestamp),
  };
}

export function toDto(notification: Notification): NotificationDto {
  const { uuid, placeUuid, message, wasShown, timestamp } = notification;
  return {
    uuid,
    placeUuid,
    message,
    wasShown,
    timestamp: timestamp.toISOString(),
  };
}
